module.exports = __webpack_public_path__ + "static/hey-grandude-ec0fe954686c30955c94d3d67efcec6a.jpg";